import React from 'react';
import IconBase, { iconPropTypes } from '../IconBase';

export default function LaundryIcon(props) {
	return (
		<IconBase type="laundry" {...props}>
			<path d="M7.75 12.75C7.33579 12.75 7 13.0858 7 13.5C7 13.9142 7.33579 14.25 7.75 14.25H11.25C11.6642 14.25 12 13.9142 12 13.5C12 13.0858 11.6642 12.75 11.25 12.75H7.75Z" />
			<path d="M18 5.5C18 6.05228 17.5523 6.5 17 6.5C16.4477 6.5 16 6.05228 16 5.5C16 4.94772 16.4477 4.5 17 4.5C17.5523 4.5 18 4.94772 18 5.5ZM17.5 5.5C17.5 5.22386 17.2761 5 17 5C16.7239 5 16.5 5.22386 16.5 5.5C16.5 5.77614 16.7239 6 17 6C17.2761 6 17.5 5.77614 17.5 5.5Z" />
			<path d="M19.5 4C19.5 3.44772 16.1421 3 12 3C7.85786 3 4.5 3.44772 4.5 4V21H6.5V20.5H17.5V21H19.5V4ZM12 19C8.96243 19 6.5 16.5376 6.5 13.5C6.5 10.4624 8.96243 8 12 8C15.0376 8 17.5 10.4624 17.5 13.5C17.5 16.5376 15.0376 19 12 19ZM15 5.5C15 5.91421 14.6642 6.25 14.25 6.25C13.8358 6.25 13.5 5.91421 13.5 5.5C13.5 5.08579 13.8358 4.75 14.25 4.75C14.6642 4.75 15 5.08579 15 5.5ZM18.5 5.5C18.5 6.32843 17.8284 7 17 7C16.1716 7 15.5 6.32843 15.5 5.5C15.5 4.67157 16.1716 4 17 4C17.8284 4 18.5 4.67157 18.5 5.5Z" />
		</IconBase>
	);
}
LaundryIcon.propTypes = iconPropTypes;
